import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import HealthCheckActions, { HealthCheckRedux, HealthCheckTypes } from '../Redux/HealthCheckRedux'
import ClassroomActions from '../Redux/ClassroomRedux'
import CenterActions from '../Redux/CenterRedux'
import InventoryActions from '../Redux/InventoryRedux'
import { notificationSuccess } from '../Redux/NotificationActions'

const healthCheckCrudObservable = createCRUDObservable({
  mainRedux: HealthCheckRedux,
  reduxPath: 'healthCheck',
})

const postHealthCheckEpic = (action$, store, { Api }) =>
  action$.ofType(HealthCheckTypes.postHealthCheckRequest)
    .mergeMap(({ studentId, data, isTeacher, fromProfile }) => (
      Observable
        .fromPromise(Api.healthCheck.postHealthCheck(studentId, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [HealthCheckActions.postHealthCheckFailure(result.error)]
          }
          const { data: { data: payload } } = result
          if (fromProfile) {
            return [
              HealthCheckActions.postHealthCheckSuccess(payload),
              notificationSuccess('Nueva Valoracion Agregada'),
              ClassroomActions.getStudentProfileRequest(
                payload.data.student.id, null, ''),
              ClassroomActions.updateCheckin(payload, isTeacher),
            ]
          }
          return [
            HealthCheckActions.postHealthCheckSuccess(payload),
            notificationSuccess('Nueva Valoracion Agregada'),
            ClassroomActions.updateCheckin(payload, isTeacher),
          ]
        })
    ))

const postVirtualHealthCheckEpic = (action$, store, { Api }) =>
  action$.ofType(HealthCheckTypes.postVirtualHealthCheckRequest)
    .mergeMap(({ student, data }) => (
      Observable
        .fromPromise(Api.healthCheck.postVirtualHealthCheck(student.id, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [HealthCheckActions.postVirtualHealthCheckFailure(response.error)]
          }
          const { data: { data: payload } } = response
          return [
            HealthCheckActions.postVirtualHealthCheckSuccess(payload.data),
            notificationSuccess('Nueva Valoracion Agregada'),
            CenterActions.updateVirtualCheckin(payload),
            ClassroomActions.updateVirtualCheckin(payload, student),
            InventoryActions.updateVirtualCheckin(payload),
            ClassroomActions.getTotalStudents(),
          ]
        })
    ))


export const healthCheckObservers = Object.assign({}, healthCheckCrudObservable.observers, {
  postHealthCheckEpic,
  postVirtualHealthCheckEpic,
})

export const healthCheckEpic = combineEpics(
  healthCheckCrudObservable.epic,
  postHealthCheckEpic,
  postVirtualHealthCheckEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/HealthCheckObservable.js